import React from 'react';

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-black/10 ">
      <div>
      <div className='flex items-center justify-center'>
      <span className="loader"></span>
      <span className="loader"></span>
      </div>
      <div className='flex items-center justify-center'>
      <span className="loader"></span>
      </div>
      </div>
    </div>
  );
};

export default Loader;
